import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { CLASSIC_DASHBOARD_KEY, syncPendoVisitorPreferences } from 'utils/pendo'

import { useLocalStorage } from '@uidotdev/usehooks'

/**
 * Watches the `?dashboard=` query param on any route and persists the
 * classic/narrative dashboard preference (localStorage + Pendo).
 *
 * Accepted values: `classic`/`0` (classic UI), `narrative`/`1` (narrative UI).
 */
export const useDashboardParam = () => {
  const { search } = useLocation()
  const [, setClassicDashboard] = useLocalStorage(CLASSIC_DASHBOARD_KEY, false)

  useEffect(() => {
    const param = new URLSearchParams(search).get('dashboard')
    if (param === 'classic' || param === '0') {
      setClassicDashboard(true)
      syncPendoVisitorPreferences({ classicDashboard: true })
    } else if (param === 'narrative' || param === '1') {
      setClassicDashboard(false)
      syncPendoVisitorPreferences({ classicDashboard: false })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])
}
